export const isValidEmail = (email: string | undefined): boolean => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const generateLevels = (val: number) => {
  const levels = [
    { label: 'Admin', value: 'admin' },
    ...Array.from({ length: val }).map((_, index) => ({
      label: `Level ${index + 1}`,
      value: `level-${index + 1}`,
    })),
  ] as { label: string; value: string }[];

  return levels;
};

export const transformFields = (fields: any) => {
  return Object.keys(fields).map((key) => ({
    label: key.charAt(0).toUpperCase() + key.slice(1),
    value: key,
    type: fields[key].type,
  }));
};
